import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/index'),
    children: [{
      path: '/',
      name: 'Home',
      component: () => import('@/views/home'),
      meta: { data: ['首页'] }
    }, {
      path: '/businessContent',
      name: 'BusinessContent',
      component: () => import('@/views/businessContent'),
      meta: { data: ['业务内容'] }
    }, {
      path: '/about',
      name: 'About',
      component: () => import('@/views/about'),
      meta: { data: ['关于我们'] }
    }//, {
      //path: '/information',
      //name: 'Information',
      //component: () => import('@/views/information'),
      //meta: { data: ['资讯中心'] }
    //},
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    from.name ? next({ name: from.name }) : next('/')
  } else {
    next()
  }
})

export default router
